import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, selectLoginStatus, selectLogoutStatus } from '../redux/modules/authSlice';
import { contentUpdate, selectContentStatus } from '../redux/modules/contentSlice';

const useInitizializeApp = () => {
	const dispatch = useDispatch();

	const loginStatus = useSelector((state) => selectLoginStatus(state));
	const logoutStatus = useSelector((state) => selectLogoutStatus(state));
	const contentStatus = useSelector((state) => selectContentStatus(state));

	useEffect(() => {
		if (loginStatus === null) {
			dispatch(login());
		}
	}, [loginStatus, dispatch]);

	useEffect(() => {
		if (loginStatus === 'success' && logoutStatus !== 'pending' && contentStatus === null) {
			dispatch(contentUpdate());
		}
	}, [loginStatus, logoutStatus, contentStatus, dispatch]);

	return loginStatus === 'error' || loginStatus === 'initialDone' || (loginStatus === 'success' && (contentStatus === 'success' || contentStatus === 'error'));
};

export default useInitizializeApp;
